import { j as r } from "../../../../_virtual/jsx-runtime.js";
import { COMMON_COLORS as e } from "../../../../constants/colors.js";
import { cn as s } from "../../../../lib/utils.js";
const x = ({
  className: a,
  bgColor: t = e.greyDark,
  children: o
}) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    className: s(
      "transform -translate-x-1/2 -translate-y-[110%] rounded-lg p-4 text-sm text-white shadow-lg flex flex-col gap-2 w-max",
      a
    ),
    style: { backgroundColor: t },
    children: [
      o,
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: "absolute left-1/2 -bottom-2 -translate-x-1/2 w-4 h-4 transform rotate-45",
          style: { backgroundColor: t }
        }
      )
    ]
  }
);
export {
  x as default
};
